import { render, staticRenderFns } from "./VEmpty.vue?vue&type=template&id=b4cd451a&"
import script from "./VEmpty.vue?vue&type=script&lang=js&"
export * from "./VEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports